import React from "react";
import ReactDOM from "react-dom/client";
// react library for routing
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

// plugins styles from node_modules
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "select2/dist/css/select2.min.css";
import "quill/dist/quill.core.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
// plugins styles downloaded
import "assets/vendor/nucleo/css/nucleo.css";
// core styles
import "assets/scss/argon-dashboard-pro-react.scss?v1.2.1";

import AdminLayout from "layouts/Admin.js";
// import RTLLayout from "layouts/RTL.js";
import AuthLayout from "layouts/Auth.js";
import IndexView from "views/Index.js";

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const root = ReactDOM.createRoot(document.getElementById("root"));

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyALYx1MxuZlLKxXS15R-53YamFN9i7dkRc",
  authDomain: "bitelogr-c7778.firebaseapp.com",
  projectId: "bitelogr-c7778",
  storageBucket: "bitelogr-c7778.appspot.com",
  messagingSenderId: "405774735455",
  appId: "1:405774735455:web:6d92e9db7bcb4dbf44e3ea",
  measurementId: "G-G7YNWGYD0P",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/admin/*" element={<AdminLayout />} />
      {/* <Route path="/rtl/*" element={<RTLLayout />} /> */}
      <Route path="/auth/*" element={<AuthLayout />} />
      <Route path="/pricing" element={<Navigate to="/auth/pricing" replace />} />
      <Route path="/about" element={<Navigate to="/auth/about" replace />} />
      <Route path="/:name?" element={<IndexView />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);
